import React from 'react';
import {BodyContainer} from "../Container/Container";
import SingleProduct from "./SingleProduct";


const StyledBodyContainer = BodyContainer.extend`
  margin-bottom: -32px;
  @media(min-width: 768px) {
      padding-bottom: 0;  
      margin-bottom: -100px;
   }
  
  @media(min-width: 992px) {
      padding-bottom: 0;  
  }
  
  @media(min-width: 1200px) {
      padding-bottom: 0;  
  }
  
  @media(min-width: 1680px) {
      padding-bottom: 0;  
  }
`;

const ProductList = (props) => {
    const {data} = props;
    return (
      <StyledBodyContainer>
          {data.map((i, index) => {
              const {acf: {title, short_description, main_image, fresh, frozen}, slug} = i.node;
                return (
                  <SingleProduct
                    key={title}
                    name={title}
                    fresh={fresh}
                    frozen={frozen}
                    summary={short_description}
                    img={main_image}
                    index={index}
                    slug={slug}
                  />
                )
            }
          )}
      </StyledBodyContainer>
    );
};

export default ProductList;



// WEBPACK FOOTER //
// ./src/components/ProductInfo/ProductList.js